import "./link.css";
import { $ as f } from "./mergeProps-F8wVfzJL.mjs";
import a, { forwardRef as _ } from "react";
import { Link as i } from "react-aria-components";
import k from "./icon.mjs";
const u = "_link_zm1km_4", g = "_large_zm1km_10", $ = "_small_zm1km_17", p = "_icon_zm1km_35", l = {
  link: u,
  large: g,
  small: $,
  icon: p
};
function L({ icon: s, iconSize: c, size: t, children: e, ...m }, n) {
  let o;
  switch (t == null ? void 0 : t.toLowerCase()) {
    case "small":
    case "sm":
      o = l.small;
      break;
    case "large":
    case "lg":
      o = l.large;
  }
  return m = f(
    m,
    {
      className: l.link
    },
    {
      className: o
    }
  ), /* @__PURE__ */ a.createElement(i, { ...m, ref: n }, s ? (r) => /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
    k,
    {
      icon: s,
      size: c ?? 20,
      color: "currentColor",
      className: l.icon
    }
  ), typeof e == "function" ? e(r) : e) : e);
}
const N = _(L);
export {
  N as default
};
